import gql from 'graphql-tag';

const getPaymentInvoiceQuery = gql`
  query GetPaymentInvoice(
    $videoId: String
    $organisationId: String!
    $orderId: String
    $isUrl: Boolean
  ) {
    getPaymentInvoice(
      videoId: $videoId
      organisationId: $organisationId
      orderId: $orderId
      isUrl: $isUrl
    ) {
      invoiceUrl
      invoiceId
      orderId
      refundedAt
      createdAt
    }
  }
`;

const getPaymentInvoice = () => ({
  query: getPaymentInvoiceQuery,
  module: 'payments',
  ignoreCache: true,
  buildVariables: ({
    invoiceId,
    orderId,
    organisationId,
    isUrl
  }: {
    invoiceId: string;
    orderId: string;
    organisationId: string;
    isUrl: boolean;
  }) => ({
    invoiceId,
    organisationId,
    orderId,
    isUrl
  })
});

export default getPaymentInvoice;
